/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pricing_Page_EyebrowInputs */

const en_directory_pricing_page_eyebrow = /** @type {(inputs: Directory_Pricing_Page_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch plans`)
};

const zh_directory_pricing_page_eyebrow = /** @type {(inputs: Directory_Pricing_Page_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布方案`)
};

/**
* | output |
* | --- |
* | "Launch plans" |
*
* @param {Directory_Pricing_Page_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pricing_page_eyebrow = /** @type {((inputs?: Directory_Pricing_Page_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pricing_Page_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pricing_page_eyebrow(inputs)
	return zh_directory_pricing_page_eyebrow(inputs)
});
export { directory_pricing_page_eyebrow as "directory.pricing_page.eyebrow" }